(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lookbook"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.mci-lookbook-grid__look button').forEach((button) => {
    button.addEventListener('click', (event) => {
      const dialog = button.closest('.mci-lookbook-grid__look').querySelector('dialog');
      dialog.showModal();
    });
  });

  document.querySelectorAll('.mci-lookbook-grid__look dialog button').forEach((button) => {
    button.addEventListener('click', (event) => {
      const dialog = button.closest('dialog');
      dialog.close();
    });
  });

  } catch(e) { console.error(e); }
})();
})();
